import React from 'react';
import InvoiceDetails from '../employee/invoices/InvoiceDetails';

/**
 * Customer Invoice View Page
 * Uses the shared InvoiceDetails component
 * InvoiceDetails already includes DashboardLayout when standalone
 */
const CustomerInvoiceView = () => {
    return <InvoiceDetails userType="customer" />;
};

export default CustomerInvoiceView;

